import { isLowerEnvironment } from "./utils";
import { AXIS_SCHEDULING_PATH_PREFIX } from "../constants/axis";

let DOMAIN = 'https://api.stitchfin.com';

// @ts-ignore
const LOCAL= "https://api.stitchfin.com";
// @ts-ignore
const DEFAULT_URL = "https://api.ovum.stitchfinapp.com";
const PROD_URL = 'https://api.stitchfinapp.com';

const clientDomainMapping: Record<string, Record<string, string>> ={
  'stluke':{
    'dev': "https://stluke.stage.api.stitchfinapp.com",
    'prod': "https://stluke.api.stitchfinapp.com",
  },
  'ovum': {
    'dev': 'https://api.ovum.stage.stitchfinapp.com',
    'prod': DEFAULT_URL,
  },
  'abchospitalportal': {
    // 'dev': "https://axis.stage.api.stitchfinapp.com",
    // 'dev': "http://localhost:8080",
    // 'dev': "https://axis.stage.api.stitchfinapp.com",
    'dev': "https://stluke.stage.api.stitchfinapp.com",
    'prod': PROD_URL,
  },
  'lavenderportal': {
    'dev': DOMAIN,
    'prod': PROD_URL,
  },
  'axis': {
    // 'dev': "https://axis.stage.api.stitchfinapp.com",
    // 'dev': "http://localhost:8080",
    'dev': "https://axis.stage.api.stitchfinapp.com",
    'prod': "https://axis.api.stitchfinapp.com",
  },
  'default': {
    // 'dev': "http://localhost:8080",
    // 'dev': "https://axis.stage.api.stitchfinapp.com",
    'dev': "https://stluke.stage.api.stitchfinapp.com",
    'prod': PROD_URL,
  }
}

export const getDomain = () => {
    const env = isLowerEnvironment() ? 'dev' : 'prod';

    if (typeof window !== 'undefined') {
        const pathname = window.location.pathname || '';
        if (pathname.startsWith(AXIS_SCHEDULING_PATH_PREFIX)) {
            const axisConfig = clientDomainMapping['axis'];
            const axisDomain = axisConfig?.[env];
            if (axisDomain) {
                return axisDomain;
            }
        }
    }

    const objs = Object.keys(clientDomainMapping);
    const client = typeof window !== 'undefined'
        ? objs.find((obj) => window.location.hostname.includes(obj)) || "default"
        : "default";
    const clientConfig = clientDomainMapping[client];
    const domain = clientConfig?.[env] || DOMAIN;
    return domain;
}

export const getSandraDomain = () => {
    if(isLowerEnvironment()) {
        return 'https://sandra1.api.stage.stitchfinapp.com/chat/';
    }
    return 'https://sandraprod.api.stitchfinapp.com/chat/';
}
export const SESSION_TIMEOUT_DAY = 24 * 60 * 60 * 1000;
